import React, { FC, useEffect, useState } from "react";

import { DataViewKey } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";

import { CONFIGURATION_SECTION_PATH } from "../../../components/layout/adminMenu";
import { Template } from "../../../models/configuration/definitions/template";
import { KTemplatesTemplatesName } from "../../../providers/config/utils";
import useFrontEditKTemplates from "../../../providers/frontEdit/hooks/useFrontEditKTemplates";
import KTemplateWrapper from "../../widgets/KTemplates/KTemplatesWrapper";
import { WidgetConfigurations } from "../../widgets/models";
import { getPathFromSectionDataKey } from "../utils";
import FrontEditTemplatesWrapper from "./FrontEditTemplatesWrapper";

export type FrontEditKTemplatesProps = {
  templatesLocation: {
    templatesPage: CONFIGURATION_SECTION_PATH;
    templatesName: KTemplatesTemplatesName;
  };
  templatesConfigurationPreloaded: Template[];
  widgetsConfigurationPreloaded: WidgetConfigurations;
  dataViewKey: DataViewKey;
} & BaseComponentProps;

const FrontEditKTemplates: FC<FrontEditKTemplatesProps> = function ({
  templatesLocation,
  templatesConfigurationPreloaded,
  widgetsConfigurationPreloaded,
  className,
  style,
  dataViewKey,
}) {
  const [hovered, setHovered] = useState<number | undefined>(undefined);
  const {
    dataOfMultipleSection,
    dataOfMultipleSectionLoading,
    currentContentEdits,
    handleReorderSections,
    handleInvertSections,
    localSectionList,
    setLocalSectionList,
  } = useFrontEditKTemplates(templatesLocation);

  useEffect(() => {
    if (dataOfMultipleSection.length !== 0) {
      const currentContentEdit = currentContentEdits.find(
        (currentContentEdit) =>
          currentContentEdit.endpoint === getPathFromSectionDataKey(dataOfMultipleSection[0].key),
      );

      const sectionList =
        currentContentEdit && currentContentEdits.length !== 0
          ? currentContentEdit.data[templatesLocation.templatesName]
          : templatesConfigurationPreloaded;

      setLocalSectionList(sectionList);
    }
  }, [
    currentContentEdits,
    dataOfMultipleSection,
    setLocalSectionList,
    templatesConfigurationPreloaded,
    templatesLocation.templatesName,
  ]);

  return (
    <Box
      className={clsx("FrontEditKTemplates", className)}
      style={style}
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {localSectionList.map((template, indexT) => {
        return (
          <FrontEditTemplatesWrapper
            key={indexT}
            indexT={indexT}
            hovered={indexT === hovered}
            setHovered={setHovered}
            sectionList={localSectionList}
            loading={dataOfMultipleSectionLoading}
            handleInvertSections={handleInvertSections}
            handleReorderSections={handleReorderSections}
          >
            <KTemplateWrapper
              key={indexT}
              classNameIndex={indexT}
              template={template}
              widgetsConfigurationPreloaded={widgetsConfigurationPreloaded}
              dataViewKey={dataViewKey}
            />
          </FrontEditTemplatesWrapper>
        );
      })}
    </Box>
  );
};

export default FrontEditKTemplates;
